import React, { useState, useEffect } from 'react';
import { IoChevronBackSharp, IoChevronForwardSharp } from "react-icons/io5"
import { goToFormNextPage, goToFormPreviousPage, setPage } from '../../../utility/utility';
const FormHeader = (props) => {
    const [inputPage, setInputPage] = useState(props.currentPage);

    const handleGoPrev = () => {
        goToFormPreviousPage(props.currentPage, props.setCurrentPage)
    }
    const handleGoForw = () => {

        goToFormNextPage(props.currentPage, props.pageIds, props.setCurrentPage);
    }
    useEffect(() => {
        setInputPage(props.currentPage); // keep input in sync when prop changes
    }, [props.currentPage]);

    return (
        <>
            <div className='AppFormBar noShadow'>
                <div className='title'>
                    <input
                        value={props.applicationName}
                        readOnly
                        style={{
                            width: "100%",
                            background: "#323639",
                            padding: "5px",
                            fontWeight: "",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#fff",
                            border: "none"
                        }} />

                </div>
                <div className='pagination'>
                    <div className='pageNum d-flex align-items-center'>
                        <IoChevronBackSharp onClick={handleGoPrev} />

                        <input
                            type="number"
                            value={inputPage}
                            style={{
                                width: '50px',
                                padding: '0px',
                                background: '#191b1c',
                                color: 'white',
                                borderRadius: '5px',
                                textAlign: 'center',
                                appearance: 'none',
                                borderWidth: 'medium',
                                borderStyle: 'none',
                                borderColor: 'currentcolor',
                                borderImage: 'none',
                            }}
                            min="1"
                            max={Number(props.pageIds.length)}
                            onBeforeInput={(e) => {
                                if (!/^\d$/.test(e.data)) {
                                    e.preventDefault(); // Only allow digit input
                                }
                            }}
                            onChange={(e) => {
                                const value = e.target.value;
                                setInputPage(value); // update local state for controlled input
                                if (value !== '') {
                                    const pageNum = parseInt(value);
                                    if (!isNaN(pageNum)) {
                                        setPage(pageNum, props.currentPage, props.pageIds, props.setCurrentPage);
                                    }
                                }
                            }}
                            onFocus={(e) => e.target.select()}
                            onMouseUp={(e) => e.preventDefault()}
                        />

                        <span className='slash'>{`/`}<span style={{ marginLeft: 10 }}>{props.totalPages}</span></span>
                        <IoChevronForwardSharp onClick={handleGoForw} />
                    </div>
                </div>

            </div>
        </>
    )
}

export default FormHeader;